import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "../../../utils/api";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import ProfileIcon from "../../../layout/assets/images/Navbar/pexels-beardo.png";
import "./index.scss";
import moment, { MomentInput } from "moment";

function GeneralEnquiryDetails() {
  const theme = useTheme();
  const borderColor = theme.palette.divider;
  let { primary_id } = useParams();
  useEffect(() => {
    getData();
  }, [primary_id]);

  const navigate = useNavigate();
  const [data, setData] = useState<any>({
    // contact_us_id: 0,
    first_name: "",
    last_name: "",
    email_id: "",
    phone_number: "",
    resume: "",
    resume_url: "",
    resume_id: "",

    // contact_us_id: 0,
  });

  const [loadingLogo, setLoadingLogo] = useState(false);

  const [memberData, setMemberData] = useState({});

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    const newFormattedDate = formattedDate.replace(",", "");

    const [month, day, year] = newFormattedDate.split(" ");
    return `${day} ${month} ${year}`;
  };

  const getData = async () => {
    var params = {};
    params = { general_enquiry_id: Number(primary_id) };
    console.log(params);

    await get(`general_enquiry/details`, params)
      .then((res) => {
        console.log("res", res.data);
        setData(res.data);
        setMemberData(res.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  console.log("data", memberData);

  const capitalize = (string: any) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <div
      className="container"
      style={{ marginTop: "22px", paddingLeft: "20px" }}
    >
      <div className="row new-client-header">
        <div className="col-xs-12">
          <h5>Contact Us Details</h5>
        </div>
      </div>
      <div style={{ maxWidth: "1152px" }}>
        <div className="row mt-3 mb-3">
          <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
            <span>First Name</span>
          </div>
          <div className="col-xs-12 col-md-8 col-lg-8">
            <span>{data.first_name}</span>
          </div>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
            <span>Last Name</span>
          </div>
          <div className="col-xs-12 col-md-8 col-lg-8">
            <span>{data.last_name}</span>
          </div>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
            <span>Email ID</span>
          </div>
          <div className="col-xs-12 col-md-8 col-lg-8">
            <span>{data.email}</span>
          </div>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
            <span>Phone Number</span>
          </div>
          <div className="col-xs-12 col-md-8 col-lg-8">
            <span>{data.phone_number}</span>
          </div>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
            <span>Message</span>
          </div>
          <div className="col-xs-12 col-md-8 col-lg-8">
            <span>{data.message}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralEnquiryDetails;
